"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberToWords = void 0;
// number to words
const numberToWords = (num) => {
    const units = [
        "zero",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "ten",
        "eleven",
        "twelve",
        "thirteen",
        "fourteen",
        "fifteen",
        "sixteen",
        "seventeen",
        "eightteen",
        "nineteen",
        "twenty",
    ];
    const tens = [
        "zero",
        "ten",
        "twenty",
        "thirty",
        "fourty",
        "fifty",
        "sixty",
        "seventy",
    ];
    const hundreds = [
        "zero",
        "one hundred",
        "two hundred",
        "three hundred",
        "four hundred",
        "five hundred",
        "six hundred",
        "seven hundred",
    ];
    if (num < 20) {
        return units[num];
    }
    else if (num < 100) {
        return tens[Math.floor(num / 10)] + " " + units[num % 10];
    }
    else if (num < 1000) {
        return (hundreds[Math.floor(num / 100)] +
            " " +
            tens[Math.floor((num % 100) / 10)] +
            " " +
            units[num % 10]);
    }
};
exports.numberToWords = numberToWords;
